/**
 * Product telemetry, decoupled from any platform SDK.
 *
 * Shared code reports through `trackEvent` / `trackException`; each app registers the sink that
 * actually sends (the web app registers Application Insights). With no sink registered every call
 * is a no-op, so tests and unconfigured regions send nothing.
 */
export type TelemetryProperties = Record<string, string>;

export interface TelemetrySink {
  trackEvent(name: string, properties?: TelemetryProperties): void;
  trackException(error: Error, properties?: TelemetryProperties): void;
}

let sink: TelemetrySink | null = null;

/** Sets where telemetry goes. Pass null to stop sending, e.g. on sign-out. */
export const registerTelemetrySink = (next: TelemetrySink | null): void => {
  sink = next;
};

/** Records a named product event, such as `catalogue.opened`. */
export const trackEvent = (
  name: string,
  properties?: TelemetryProperties,
): void => {
  sink?.trackEvent(name, properties);
};

/** Records a handled or unhandled error. */
export const trackException = (
  error: Error,
  properties?: TelemetryProperties,
): void => {
  sink?.trackException(error, properties);
};
